import React, { useState, useEffect } from 'react';
import styles from './AppleHeader.module.css';
import { Nav, NavbarBrand, NavItem, NavLink, Container, NavbarToggler, Collapse, Navbar } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { useHistory, useLocation } from 'react-router-dom';
import { ReactComponent as AIGLogo } from '../../../assets/images/aig-logo.svg';
import { getCustomerRedirectUrls } from '../../../helpers';
import ResumePurchaseModal from '../../Sales/ResumePurchaseModal';

export default function AppleHeader() {
    const history = useHistory();
    const location = useLocation();
    const [navOptions, setNavOptions] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 576px)' });
    const [coverageDocsLink, setCoverageDocsLink] = useState('');
    const [myPlanLink, setMyPlanLink] = useState('');
    const currentPathname = location?.pathname || '';
    const [showModal, setShowModal] = useState(false);

    const toggleNavbar = () => {
        setNavOptions(!navOptions);
    };

    const getRedirectLinks = async () => {
        const data = await getCustomerRedirectUrls('apple').then((urlResponse) => {
            return {
                coverageURL: urlResponse?.coverageDocsUrl,
                customerLoginURL: urlResponse?.customerPortalLoginUrl
            };
        });
        setCoverageDocsLink(data?.coverageURL);
        setMyPlanLink(data?.customerLoginURL);
    };

    useEffect(() => {
        //Fetch Redirect Links for Nav Links
        getRedirectLinks();
    }, []);

    const handleLogoClick = (e) => {
        e && e.preventDefault();

        if (
            currentPathname === '/buy/protectionplan'
            || currentPathname === '/buy/reviewplan'
            || currentPathname === '/customerinfo'
            || currentPathname === '/sales/payment'
        ) {
            setShowModal(true);
        } else {
            window.location.href = '/';
        }
    };

    const handleCancelPurchase = () => {
        setShowModal(false);
        history.push('/');
    };

    return (
        <>
            <header className={styles.headerContainer}>
                <Container>
                    <Navbar
                        color='faded'
                        light
                        expand='sm'
                        className={styles.navbarContainer}
                    >
                        <NavbarBrand>
                            <AIGLogo
                                className={styles.navBarLogo}
                                onClick={handleLogoClick}
                            />
                        </NavbarBrand>
                        <NavbarToggler
                            className={styles.navToggler}
                            onClick={toggleNavbar}
                        />
                        {!isMobile && (
                            <Collapse
                                isOpen={navOptions}
                                navbar
                            >
                                <Nav
                                    navbar
                                    className={'ml-auto'}
                                >
                                    <NavItem>
                                        <NavLink
                                            tabIndex={0}
                                            className={styles.navLinkApple}
                                            href={coverageDocsLink}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            Coverage Documents
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            tabIndex={1}
                                            className={styles.navLinkApple}
                                            href={myPlanLink}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            Manage My Plan
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Collapse>
                        )}
                    </Navbar>
                </Container>
            </header>

            {isMobile && (
                <>
                    <Collapse
                        isOpen={navOptions}
                        navbar
                    >
                        <Nav
                            navbar
                            className={styles.navTabsApple}
                            onClick={toggleNavbar}
                        >
                            <NavItem>
                                <NavLink
                                    tabIndex={0}
                                    className={styles.navLinkApple}
                                    href={coverageDocsLink}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Coverage Documents
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    tabIndex={1}
                                    className={styles.navLinkApple}
                                    href={myPlanLink}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Manage My Plan
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </>
            )}

            {showModal && (
                <ResumePurchaseModal
                    isOpen={showModal}
                    cancelAction={handleCancelPurchase}
                    toggle={() => setShowModal(false)}
                />
            )}
        </>
    );
}
